/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%;width:100%}[_nghost-%COMP%]   div.page[_ngcontent-%COMP%]{width:100%}.driverId[_ngcontent-%COMP%]{float:right}"];
export { styles as styles };
